const dateFormats = {
    USA_DATETIME: 'MM/DD/YYYY h:mm A',
    USA_DATE: 'MM/DD/YYYY',
    USA_DATE_LONG: 'MMMM D, YYYY',
    USA_DATE_TIME_LONG: 'MMMM D, YYYY h:mm A',
    USA_TIME: 'h:mm A',
};

export default dateFormats;
